import React from 'react'
import mello from "./images/mello.svg"
import { FaSmileWink } from "react-icons/fa";
function Welcome() {
    return (
        <div className="spinner spinner-m" >
            <img src={mello} alt="welcome" />
            <h3 className="greet">Hello! Welcome <FaSmileWink /></h3>

        </div>
    )
}

export default Welcome
